class LoadMoreSection extends HTMLElement {
  connectedCallback() {
    this.section = this.querySelector('[data-team-section]');
    this.button = this.querySelector('[data-load-more]');
    this.buttonsContainer = this.querySelector('[data-load-more-container]');
    this.loadLessText = this.querySelector('[data-load-less-text]');
    this.loadMoreText = this.querySelector('[data-load-more-text]');
    this.expanded = false;

    if (!this.section || !this.button) {
      console.error('Required elements not found');
      return;
    }

    this.button.addEventListener('click', () => this.showSection());
  }

  showSection() {
    if (!this.expanded) {
      this.section.classList.add('!max-h-full');
      this.loadMoreText.classList.add('hidden');
      this.loadLessText.classList.remove('hidden');
    } else {
      this.section.classList.remove('!max-h-full');
      this.loadMoreText.classList.remove('hidden');
      this.loadLessText.classList.add('hidden');
    }
    this.expanded = !this.expanded;
  }
}

customElements.define('load-more-section', LoadMoreSection);
